
            const data = {"name":"glyph/24/calendar-lightblue","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M23 3h-5V1a1 1 0 0 0-2 0v2H8V1a1 1 0 0 0-2 0v2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-1 18H2V7h20Z\" class=\"nc-icon-wrapper\" _fill=\"#0073E6\"/>","originalColors":[{"type":"fill","color":"#0073E6"}],"stopColors":[]}}
        
                    module.exports = data
                    